import React from "react";

import { Row , Col} from "reactstrap";

import { ReactComponent as CodeSvg } from '../../../../assets/images/code.svg';
import { ReactComponent as FireSvg } from '../../../../assets/images/fire.svg';
import { ReactComponent as CustomerSvg } from '../../../../assets/images/customer.svg';
import BaseBox from "../../../common/BaseBox";

import './style.scss'; 

export default function Values () {
    return (
        <Row className="values">
            <Col xs={12}>
                <h2 className="heading-2"> Our Values</h2>
            </Col>
            <BaseBox degreesShame={0} Icon={CodeSvg} title={"Flexible & Transparent Solutions"} description={"Our team adapts to your needs, offering seamless integration at a transparent price."}/>
            <BaseBox degreesShame={180} Icon={FireSvg} title={"Skilled Professionals on Demand"} description={"Gain access to top-tier developers, designers, and QA specialists without the overhead of permanent hires."}/>
            <BaseBox degreesShame={90} Icon={CustomerSvg} title={"Your Goals, Our Mission"} description={"Our team adapts to your needs, offering seamless integration at a transparent price."}/>
        </Row>
    )
}
